module.exports = __webpack_public_path__ + "img/dashboard2_p.7185839c.svg";